import { styled } from '@/stitches.config';

const PageTitle = styled('h1', {
  color: '$textPrimary',
  paddingLeft: '$0',
});

export default PageTitle;
